module.exports = __webpack_public_path__ + "static/media/Rectangle 90.c6d648bb.png";